import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json'
	})
};

class ProductForm {
	product_name: string;
	consignor_name:string;
	packing : string;	
	branch:string;
}

@Injectable()
export class ProductService {

	private url = environment.url 

	constructor(private http: HttpClient) { }


	addNewProduct(form): Observable<string>{
		return this.http.post<string>(this.url + '/masters/product/submit', form, http_options);
	};
	getAllProduct(): Observable<ProductForm[]> {
		return this.http.get<ProductForm[]>(this.url + '/masters/product/all');
	};
	getProductFormWith(consignor_name: any ,name:string): Observable<ProductForm[]> {
		console.log (this.http.get<ProductForm[]>(this.url + '/masters/product/get/' + consignor_name.toString() + "/" + name.toString()));
		return this.http.get<ProductForm[]>(this.url + '/masters/product/get/' + consignor_name.toString() + "/" + name.toString());
	};
	getProductByClientName(name:string): Observable<ProductForm[]> {
		return this.http.get<ProductForm[]>(this.url + '/masters/product/get/client/' + name);
	};
}




// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/_services/_masters/product.service.ts